@if (params.value) {
  @if (params.value?.editable) {
    <mat-slide-toggle
      [color]="'primary'"
      [checked]="params.value.value"
      (click)="checkedHandler($event, params.value.value)"
    />
  } @else {
    @if (params.value.value) {
      <mat-icon
        class="green-icon"
        [svgIcon]="EsvgFiles.correct"
      />
    } @else {
      <mat-icon
        class="red-icon"
        [svgIcon]="EsvgFiles.close"
      />
    }
  }
}
